export default __webpack_public_path__ + "static/media/learn-more-card-10.5910328b.svg";